import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { Text, OutlineButton, Colors } from 'library';
import AddIcon from '@material-ui/icons/Add';
import { track } from 'shared';
import ComingSoonGroupDialog from '../../ComingSoonGroupDialog';
import { isLoggedIn } from 'api/UserApi';
import { isMobile } from 'react-device-detect';
import useSignUpAction from 'parent-portal/login/SignUpAction';

export default function GroupHeader() {
    const [openDialog, setOpenDialog] = useState(false);
    const { signUp, SignUpWrapper } = useSignUpAction(handleClose);

    function handleJoinButton() {
        if (isLoggedIn()) {
            track('Groups: Create new group button clicked, coming soon dialog shown');
            setOpenDialog(true);
        } else {
            track('Groups: Create new group button clicked from public view, sign up modal shown');
            signUp('Public Group List Page');
        }
    }

    function handleClose() {
        if (isLoggedIn()) {
            track('Group List Public View: User Created');
        } else {
            track('Group List Public View: User Not Created');
        }
    }

    return (
        <>
            <Grid container>
                <Grid item container justify="space-between" alignItems="center">
                    <Text variant="h1" bold>
                        Connect with your neighbors.
                    </Text>
                    {!isMobile ? (
                        <Grid item>
                            <OutlineButton onClick={() => handleJoinButton()}>
                                <AddIcon style={{ paddingBottom: 2 }} /> Create new group
                            </OutlineButton>
                        </Grid>
                    ) : null}
                </Grid>
                <Grid item container>
                    <Text variant="body1" color={Colors.darkGrey} textStyle={{ marginTop: 6, marginBottom: 30 }}>
                        Communicate with people in your area who are also finding care providers through Tandem!
                    </Text>
                </Grid>
                <ComingSoonGroupDialog feature={'Creating'} open={openDialog} onClose={() => setOpenDialog(false)} />
            </Grid>
            <SignUpWrapper message={'Create your free account to create new groups'} />
        </>
    );
}
